import { render, staticRenderFns } from "./ConsensusSettingsPanel.vue?vue&type=template&id=30598bb4&"
import script from "./ConsensusSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./ConsensusSettingsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
